import React, { useEffect, useState } from 'react'
import './styles/additional-settings.scss'
import { CaretLeft } from '@phosphor-icons/react'
import { Button } from 'antd'
import ButtonSpinner from 'components/global/ButtonSpinner'
import { classesEventStore } from 'state/classes/classesStore'
import CoverAndDescription from './essentialComp/CoverAndDescription'
import AdditionalSettings from './essentialComp/AdditionalSettings'
import Confirmationmodal from './Modals/Confirmationmodal'
import { UpdateClassStep7Body } from 'types/Classes/Classes'
import { useEditStep7Mutation } from 'api/Classes/Classes'
import { RequiredDeatilsTypes, KidsRequiredDetails, ParentRequiredDetailsType } from 'types/event/eventStep5'

interface AdditionalClassSettingsProps {
  handleNext: (data: any) => void
  handleBack: () => void
}

const AdditionalClassSettings: React.FC<AdditionalClassSettingsProps> = ({
  handleNext,
  handleBack,
}) => {
  const [confirmModal, setConfirmModal] = useState<boolean>(false)
  
  const classesData = classesEventStore(store => store.classesData)
  const setClassesData = classesEventStore(store => store.setClassesData)
  const agreements = classesEventStore(store => store.agreements)
  const setAgreements = classesEventStore(store => store.setAgreements)
  const itemsToBring = classesEventStore(store => store.itemsToBring)
  const setItemsToBring = classesEventStore(store => store.setItemsToBring)
  const selectedFaqIds = classesEventStore(store => store.selectedFaqIds)
  const setSelectedFaqIds = classesEventStore(store => store.setSelectedFaqIds)
  const selectedRequiredDocumentIds = classesEventStore(store => store.selectedRequiredDocumentIds)
  const setSelectedRequiredDocumentIds = classesEventStore(store => store.setSelectedRequiredDocumentIds)
  const emailTemplates = classesEventStore(store => store.emailTemplates)
  const setEmailTemplates = classesEventStore(store => store.setEmailTemplates)
  const requiredDetails = classesEventStore(store => store.requiredDetails)
  const setRequiredDetails = classesEventStore(store => store.setRequiredDetails)

  const { mutate: step7Mutation, isLoading: step7Loading } = useEditStep7Mutation()

  const mapToKeyValueObject = (arr: RequiredDeatilsTypes[]) => {
    return arr?.reduce(
      (acc, item) => {
        acc[item.key] = item.value
        return acc
      },
      {} as ParentRequiredDetailsType | KidsRequiredDetails,
    )
  }

  const handleStep7CompleteClick = () => {
    const payload: UpdateClassStep7Body = {
      requiredDocumentIds: selectedRequiredDocumentIds,
      itemsToBringIds: itemsToBring,
      faqIds: selectedFaqIds,
      agreementIds: agreements,
      parentRequiredDetails: mapToKeyValueObject(
        requiredDetails?.guardians || [],
      ) as ParentRequiredDetailsType,
      authorizedAdultRequiredDetails: mapToKeyValueObject(
        requiredDetails?.adults || [],
      ) as ParentRequiredDetailsType,
      kidsRequiredDetails: mapToKeyValueObject(
        requiredDetails?.kids || [],
      ) as KidsRequiredDetails,
      emailTemplateIds: emailTemplates?.map((template: any) => template._id || template.id) || [],
    }

    step7Mutation(
      { body: payload, classId: classesData._id },
      {
        onSuccess: data => {
          setClassesData({ ...classesData, ...data })
          handleNext(data)
        },
      },
    )
  }

  useEffect(() => {
    setItemsToBring(classesData.itemsToBringIds || [])
    setSelectedFaqIds(classesData.faqIds || [])
    setSelectedRequiredDocumentIds(classesData.requiredDocumentIds || [])
    setAgreements(classesData.agreementIds || [])
    setEmailTemplates(classesData.emailTemplates || [])
    setRequiredDetails(classesData.requiredDetails || {
      guardians: [
        { title: 'Profile Photo', key: 'profilePhoto', value: false },
        { title: 'Relation', key: 'relation', value: false },
        { title: 'Gender', key: 'gender', value: false },
        { title: 'Date of Birth', key: 'dateOfBirth', value: false },
        { title: 'Email', key: 'email', value: false },
        { title: 'Phone Number', key: 'phoneNumber', value: false },
        { title: 'Home Address', key: 'homeAddress', value: false },
        { title: 'Allergies', key: 'allergies', value: false },
        { title: 'Medical Notes', key: 'medicalNotes', value: false },
      ],
      adults: [
        { title: 'Profile Photo', key: 'profilePhoto', value: false },
        { title: 'Relation', key: 'relation', value: false },
        { title: 'Gender', key: 'gender', value: false },
        { title: 'Date of Birth', key: 'dateOfBirth', value: false },
        { title: 'Email', key: 'email', value: false },
        { title: 'Phone Number', key: 'phoneNumber', value: false },
        { title: 'Home Address', key: 'homeAddress', value: false },
        { title: 'Allergies', key: 'allergies', value: false },
        { title: 'Medical Notes', key: 'medicalNotes', value: false },
      ],
      kids: [
        { title: 'Profile Photo', key: 'profilePhoto', value: false },
        { title: 'Gender', key: 'gender', value: false },
        { title: 'Date of Birth', key: 'dateOfBirth', value: false },
        { title: 'School', key: 'school', value: false },
        { title: 'Grade', key: 'grade', value: false },
        { title: 'Weight', key: 'weight', value: false },
        { title: 'Height', key: 'height', value: false },
        { title: 'Allergies', key: 'allergies', value: false },
        { title: 'Medical Notes', key: 'medicalNotes', value: false },
      ],
    })
  }, [])

  return (
    <div className="step3-main-container">
      <div className="content scroller overflow-auto-y">
        <h3 className="text-24 w-600"> Step 7. Communication</h3>
        <div className="mt-30px overflow-auto-y scroller overflow-hidden-x content-container">
          <AdditionalSettings />
        </div>
      </div>

      <div className="mt-15px event-button-cont">
        <h5
          className="flex gap-10px align-center pointer"
          onClick={() => handleBack()}
        >
          <CaretLeft size={20} color="#000" />
          <span className="text-15 w-500">Back</span>
        </h5>
        <Button className="stepper-button" onClick={handleStep7CompleteClick}>
          {step7Loading ? <ButtonSpinner size={20} color="#000" /> : 'Next'}
        </Button>
      </div>

      {confirmModal && (
        <Confirmationmodal
          openModal={confirmModal}
          closeModal={setConfirmModal}
          handleNext={handleStep7CompleteClick}
        />
      )}
    </div>
  )
}

export default AdditionalClassSettings
